import React from 'react';
import PropTypes from 'prop-types';
import getConfig from 'next/config';

import { RouteContext } from 'lib/ContextTypes';
import { children as ChildrenPropType } from 'lib/CustomPropTypes';
import getRelativePathBasedOnDomain from 'lib/getRelativePathBasedOnDomain';

const Link = (props) => {
  const route = React.useContext(RouteContext);

  // Copy props to attribs without invalid ones
  const elementAttribs = () => {
    const {
      publicRuntimeConfig: {
        ENABLE_RELATIVE_LINKS,
      },
    } = getConfig();

    const {
      domain, children, to, href, host, className, deviceUrl,
      ...attribs
    } = props;

    const getLinkHref = () => {
      // "to" property was used for SPA
      // consolidate with href now that SPA is deprecated
      const url = to || href || null;
      let relativePath;

      if (ENABLE_RELATIVE_LINKS && !/^(mailto|sms|tel)/i.test(url)) {
        // use relative paths for environment based testing
        relativePath = getRelativePathBasedOnDomain(url, route.domain, route.host);
      }

      return relativePath || url;
    };

    const linkAttributes = {
      href: getLinkHref() || deviceUrl,
      ...attribs,
    };

    return linkAttributes;
  };

  const { children, className } = props;

  const linkAttributes = elementAttribs();

  return (
    <a
      {...linkAttributes}
      className={className}
    >
      {children}
    </a>
  );
};

Link.propTypes = {
  children: ChildrenPropType.isRequired,
  className: PropTypes.string,
  deviceUrl: PropTypes.string,
  domain: PropTypes.string,
  host: PropTypes.string,
  href: PropTypes.string,
  to: PropTypes.string,
};

Link.defaultProps = {
  className: null,
  deviceUrl: null,
  domain: null,
  host: null,
  href: null,
  to: null,
};

export default Link;
